import React, { useState, useEffect } from 'react'
import Classes from './Tickets.module.css'
import useScreenWidth from '../../../../../Hooks/useScreenWidth';
import SkeletonLoading from '../../../../GlobalComponents/SkeletonLoading/SkeletonLoading';
import { useSelector } from 'react-redux';
import { Pagination, Stack } from '@mui/material';
import TableRow from './TableRow';
import { useNavigate } from 'react-router-dom';

const AddIcon = (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" {...props} viewBox="0 0 448 512"><path d="M256 80c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 144L48 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l144 0 0 144c0 17.7 14.3 32 32 32s32-14.3 32-32l0-144 144 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-144 0 0-144z" /></svg>
)

export default function Tickets() {
    const tickets = [
        { id: 1, subject: "Need new logo placed here on the homepage footer...", order: "SEO", status: "Open", date: "March 1, 2025" },
        { id: 2, subject: "Need new logo placed here on the homepage footer...", order: "SEO", status: "Open", date: "March 1, 2025" },
        { id: 3, subject: "Need new logo placed here on the homepage footer...", order: "SEO", status: "Open", date: "March 1, 2025" },
        { id: 4, subject: "Need new logo placed here on the homepage footer...", order: "UI/UX", status: "Open", date: "March 1, 2025" },
        { id: 5, subject: "Need new logo placed here on the homepage footer...", order: "Website Audit", status: "Closed", date: "March 1, 2025" },
        { id: 6, subject: "Need new logo placed here on the homepage footer...", order: "Website Audit", status: "Closed", date: "March 1, 2025" },
        { id: 7, subject: "Need new logo placed here on the homepage footer...", order: "Website Audit", status: "Closed", date: "March 1, 2025" },
        { id: 8, subject: "Need new logo placed here on the homepage footer...", order: "Website Audit", status: "Closed", date: "March 1, 2025" },
    ];

    const [loading, setLoading] = useState(true);
    const navigateTo = useNavigate();
    const screenWidth = useScreenWidth();
    const isMobile = screenWidth <= 480;

    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 8;

    const totalPages = Math.ceil(tickets.length / itemsPerPage);
    const currentItems = tickets.slice(
        (currentPage - 1) * itemsPerPage,
        currentPage * itemsPerPage
    );
    const startItem = (currentPage - 1) * itemsPerPage + 1;
    const endItem = Math.min(currentPage * itemsPerPage, tickets.length);
    const totalItems = tickets.length;

    function handlePageChange(e, pageNum) {
        setCurrentPage(pageNum);
    }

    const handleAddTicket = () => {
        navigateTo('/add-ticket');
    }

    useEffect(() => {
        const timer = setTimeout(() => {
            setLoading(false);
        }, 1000);
        return () => clearTimeout(timer);
    }, []);

    return (
        <div className={Classes.hero}>
            <div className={Classes.header}>
                <div>
                    <h3>Tickets</h3>
                    <h5>Add and manage your tickets.</h5>
                </div>
                <div>
                    <div className={Classes.searcCon}>
                        <img src="/assets/images/search.png" alt="icon" />
                        <input type="text" placeholder="Search..." />
                    </div>
                </div>
            </div>

            <div className={Classes.table} >
                <div className={Classes.tableWrapper}>
                    <div className={Classes.tableBanner} >
                        <div className='flexAlign10' >
                            <div className={Classes.tableBannerItem}>
                                <h5>Open</h5>
                                <h4>3</h4>
                            </div>
                            <div className={Classes.tableBannerItem}>
                                <h5>Closed</h5>
                                <h4>4</h4>
                            </div>
                            <h5 className={Classes.allText} >All</h5>
                        </div>
                        <div>
                            <button onClick={handleAddTicket} className={Classes.addBtn}>
                                <AddIcon height='12px' fill='white' />
                                <h5>Add Ticket</h5>
                            </button>
                        </div>
                    </div>

                    <div className={Classes.tableHeader}>
                        <div className={`${Classes.headerItem} ${Classes.headerCustomer}`}>
                            <h5>Subject</h5>
                        </div>
                        <div className={`${Classes.headerItem} ${Classes.headerSpendings}`}>
                            <h5>Date</h5>
                        </div>
                        <div className={`${Classes.headerItem} ${Classes.headerBookings}`}>
                            <h5>Status</h5>
                        </div>
                        <div className={`${Classes.headerItem} ${Classes.headerDate}`}>
                        </div>
                        {/* <div className={`${Classes.headerItem} ${Classes.headerDisable}`}>
                        </div>
                        <div className={`${Classes.headerItem} ${Classes.headerActions}`}>
                        </div> */}
                    </div>

                    <div className={Classes.tableBody}>
                        {loading ? (
                            <SkeletonLoading
                                length={itemsPerPage}
                                height={isMobile ? '6rem' : '2.8rem'}
                                width="100%"
                                br="6px"
                            />
                        ) : currentItems && currentItems.length > 0 ? (
                            currentItems.map((cust, idx) => (
                                <TableRow
                                    key={cust._id}
                                    value={cust}
                                    index={idx}
                                />
                            ))
                        ) : (
                            <div>No customer found.</div>
                        )}
                    </div>

                    <div className={Classes.pagFooter}>
                        <h5 style={{ height: '1.2rem' }}>
                            {loading
                                ? <SkeletonLoading height='1.2rem' width='10rem' br='4px' padding='0' />
                                : `Showing ${startItem} to ${endItem} of ${totalItems} results`
                            }
                        </h5>
                        <Stack spacing={2} className={Classes.pagination}>
                            {loading
                                ? <SkeletonLoading height='1.2rem' width='5rem' br='4px' padding='0' />
                                : <Pagination
                                    count={totalPages}
                                    page={currentPage}
                                    onChange={handlePageChange}
                                    shape="rounded"
                                />
                            }
                        </Stack>
                    </div>
                </div>
            </div>
        </div>
    )
}
